<div class="container container-margin">
  <div class="row">
    <h2>{{ translationService.getSubstancesText() }}</h2>
  </div>

  <div class="container">
    <form [formGroup]="filterForm">
      <div class="row form-row">
        <mat-form-field
          [ngClass]="isMobileView ? 'filter-field-mobile' : 'filter-field'"
          appearance="outline"
        >
          <mat-label>{{ translationService.getRegulationText() }}</mat-label>
          <mat-select formControlName="regulationId" name="regulationId">
            @for (regulation of regulations; track regulation) {
              <mat-option [value]="regulation.id"
                >{{ regulation.fullName }} ({{
                  regulation.shortName
                }})</mat-option
              >
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div [ngClass]="!isMobileView ? 'grid-container' : ''">
        <mat-form-field
          [ngClass]="isMobileView ? 'filter-option-mobile' : 'filter-option'"
          appearance="outline"
        >
          <mat-label>{{ translationService.getNameText() }}</mat-label>
          <input matInput formControlName="name" type="text" name="name" />
        </mat-form-field>

        <mat-form-field
          [ngClass]="isMobileView ? 'filter-option-mobile' : 'filter-option'"
          appearance="outline"
        >
          <mat-label>{{ translationService.getCasNumberText() }}</mat-label>
          <input
            matInput
            formControlName="casNumber"
            type="text"
            name="casNumber"
          />
        </mat-form-field>
      </div>

      <div [ngClass]="!isMobileView ? 'row form-row align-right' : ''">
        <button
          mat-stroked-button
          color="primary"
          [ngClass]="isMobileView ? 'filter-button-mobile' : 'filter-button'"
          type="button"
          (click)="resetFilter()"
        >
          <mat-icon>refresh</mat-icon>
          {{ translationService.getResetFilterText() }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [ngClass]="isMobileView ? 'filter-button-mobile' : 'filter-button'"
          type="button"
          (click)="getRegulationSubstances()"
        >
          <mat-icon>search</mat-icon>
          {{ translationService.getFilterResultsText() }}
        </button>
      </div>
      <h2>
        <span
          >{{ regulationSubstanceResults.totalRecords }}
          {{ translationService.getResultOptionalSText() }}</span
        >
      </h2>
      <app-substance-list
        [substances]="regulationSubstanceResults.results"
        [displayedColumns]="displayedColumns"
      ></app-substance-list>

      <mat-paginator
        (page)="changePage($event)"
        [length]="regulationSubstanceResults.totalRecords"
        showFirstLastButtons
        pageSize="20"
      ></mat-paginator>
    </form>
  </div>
</div>
